import { Navigate, Outlet } from 'react-router-dom';
import { useTenantAuth } from '../../auth/auth';

const NonLoginRoute = () => {
  const { user } = useTenantAuth();
  return (
    <div>
      {!user ? (
        <>
          <Outlet />
        </>
      ) : (
        <Navigate to="/admin" />
      )}
    </div>
  );
};

export default NonLoginRoute;
